<template>
    <div>
        <div class="row">
            <div class="col-12">

                <div class="post-gallery-container">
                    <div style="margin-bottom: 20px;">
                        <button class="btn btn-primary" @click="showGalleryList()" style="display: inline-block;">
                            <span>{{lang("Upload from gallery")}}</span>
                        </button>

                        <button class="btn btn-danger" @click="clearPreview()" style="float: right;">
                            <i class="fa fa-ban" aria-hidden="true"></i>
                            <span style="margin-left: 5px;">{{lang("Remove All")}}</span>
                        </button>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div style="margin-top: 20px;">
                                <div class="upload-file-list-container">
                                    <div class="each-file-container"
                                         v-if="selectedFile != null && selectedFile.length > 0"
                                         v-for="(file, key) in selectedFile" :key="(file, key).id">
                                            <span class="each-file">

                                                <img v-if="checkIfImage(file)" class="preview" v-bind:ref="'image'+parseInt( key )"/>

                                                <video class="media-file-video preview" v-if="!checkIfImage(file) && file.type.toLowerCase() !== 'application/pdf'" controls
                                                       style="max-width: 100%;" v-bind:ref="'video'+parseInt( key )" :type="file.type.toLowerCase()">
                                                </video>

                                                <pdf class="media-file-video preview" v-if="!checkIfImage(file) && file.type.toLowerCase() === 'application/pdf'"
                                                     style="max-width: 100%; overflow: auto;" v-bind:ref="'pdf'+parseInt( key )" :type="file.type.toLowerCase()"></pdf>
                                            </span>

                                        <span v-if="isNull(post)" class="each-file-close" @click="removePreviewImg(file.name)" :id="(file, key).id"><strong>x</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <input type="file" multiple @change="onFileChanged" ref="fileupload" class="inputfile"
                                   id="inputfile"
                                   data-multiple-caption="{count} files selected">
                        </div>
                    </div>
                </div>

                <!-- Others content for "Feed" -->
                <form class="needs-validation form-style vs-con-loading__container" novalidate
                      @submit.prevent="onSubmit" id="div-with-loading" v-if="displayListMode === 'Feed'">

                    <!-- Content -->
                    <div class="mb-3 form-group" :class="{ 'form-group--error': $v.addPostContent.$error }">
                        <textarea type="text" class="form-control" id="postContent" v-model="addPostContent"
                                  :placeholder="lang('Please enter your content here')" v-model.trim="$v.addPostContent.$model" ></textarea>
                        <div class="error requiredFieldsMsg" v-if="!$v.addPostContent.required">
                            <el-alert
                                    :title="lang('Content is required')"
                                    type="error">
                            </el-alert>
                        </div>
                    </div>

                    <!-- Tags Component -->
                    <tags-component @tags="setTags"></tags-component>

                    <div class="mb-2"></div>

                    <!-- Button -->
                    <div class="row d-flex  form-footer">
                        <div class="col-md-6">
                            <b-btn @click="resetAll" class="float-left btn-secondary">{{lang("Cancel")}}</b-btn>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-primary " type="submit" @click="Validation">{{lang("Submit")}}
                            </button>
                        </div>
                    </div>
                </form>
                <!-- END Others content for "Feed" -->

                <!-- Others content for "Portfolio" -->
                <form @submit.prevent="verifyPost" v-if="displayListMode === 'Portfolio'">
                    <div class="form-group row pt-4">
                        <div class="col-md-6 formDiv"
                             :class="{ 'form-group--error': $v.obj_Post.PostPorDtlTitle.$error }">
                            <label for="tb_Title">{{lang("Title")}}</label>
                            <input v-model="obj_Post.PostPorDtlTitle" type="text" class="form-control" id="tb_Title"
                                   :placeholder="lang('Please enter a title')"
                                   v-model.trim="$v.obj_Post.PostPorDtlTitle.$model"/>
                            <div class="error requiredFieldsMsg" v-if="!$v.obj_Post.PostPorDtlTitle.required">
                                <el-alert
                                        :title="lang('Title is required')"
                                        type="error">
                                </el-alert>
                            </div>
                        </div>
                        <div class="col-md-6 formDiv"
                             :class="{ 'form-group--error': $v.obj_Post.PostPorDtlObservation.$error }">
                            <label for="tb_Observation">{{lang("Observations")}}</label>
                            <textarea v-model="obj_Post.PostPorDtlObservation" type="text" class="form-control"
                                      id="tb_Observation"
                                      :placeholder="lang('Please enter your observations')"
                                      v-model.trim="$v.obj_Post.PostPorDtlObservation.$model"></textarea>
                            <div class="error requiredFieldsMsg" v-if="!$v.obj_Post.PostPorDtlObservation.required">
                                <el-alert
                                        :title="lang('Observations is required')"
                                        type="error">
                                </el-alert>
                            </div>
                        </div>
                        <div class="col-md-6 formDiv" :class="{ 'form-group--error': $v.ddlClass.$error }">
                            <label>{{lang("Class")}}</label>
                            <el-select v-model="ddlClass" :placeholder="lang('Select Class')"
                                       class="pro-edt-select fullWidth mb-3"
                                       @change="changeClass()" v-model.trim="$v.ddlClass.$model">
                                <el-option
                                        v-for="item in ddlClassList"
                                        :key="item.PK_Class_ID"
                                        :label="item.CLS_ClassName.trim() + ' ' +item.CLS_Batch.trim()"
                                        :value="item.PK_Class_ID.trim()">
                                </el-option>
                            </el-select>
                            <div class="error requiredFieldsMsg" v-if="!$v.ddlClass.required">
                                <el-alert
                                        :title="lang('Class is required')"
                                        type="error">
                                </el-alert>
                            </div>
                        </div>
                        <div class="col-md-6 formDiv"
                             :class="{ 'form-group--error': $v.obj_Post.PostPorDtlDevelopmentGoals.$error }">
                            <label>{{lang("Developmental Goals")}} ( <i class="material-icons">assignment_ind</i> = Assigned )</label>
                            <el-select v-model="obj_Post.PostPorDtlDevelopmentGoals" :placeholder="lang('Select Development Goals')" multiple
                                       class="pro-edt-select fullWidth mb-3 postPortfolioComponentPage"
                                       @change="setValidateDropdown(obj_Post.PostPorDtlDevelopmentGoals)">
                                <!--                                <el-option-->
                                <!--                                        v-for="item in ddlGoalsList"-->
                                <!--                                        class="ddlDevelopmentGoalsOption"-->
                                <!--                                        :class = "{ 'ddlDevelopmentGoalsOptionBGColor' : item.Included === 'Yes' }"-->
                                <!--                                        :key="item.PlnStaIndicator.trim()"-->
                                <!--                                        :label="item.PlnStaIndicator.trim()"-->
                                <!--                                        :value="item.PlnStaIndicator.trim()">-->
                                <!--                                    <span style="float: left"><i class="material-icons" v-if="item.Included === 'Yes'">assignment_ind</i> {{item.PlnStaIndicator.trim()}}</span>-->
                                <!--                                </el-option>-->
                                <!--                                sortedGoalList-->

                                <el-option-group v-for="group in sortedGoalList" :key="group.Str_SortBy" :label="group.Str_SortBy">
                                    <el-option v-for="item in group.ArrObj_Items"
                                               class="ddlDevelopmentGoalsOption"
                                               :class = "{ 'ddlDevelopmentGoalsOptionBGColor' : item.Included === 'Yes' }"
                                               :key="item.PlnStaIndicator.trim()"
                                               :label="item.PlnStaIndicator.trim()"
                                               :value="item.PlnStaIndicator.trim()">
                                    </el-option>
                                </el-option-group>
                            </el-select>
                            <div class="error requiredFieldsMsg"
                                 v-if="!$v.obj_Post.PostPorDtlDevelopmentGoals.required">
                                <el-alert
                                        :title="lang('Developmental Goals is required')"
                                        type="error">
                                </el-alert>
                            </div>
                        </div>
                        <div v-if="porDevelopmentObject.length>0" class="col-md-12 formDiv">
                            <label>{{lang("You have selected")}}</label>

<!--                            <table class=" w-100">-->
<!--                                <thead class="table-thead">-->
<!--                                <tr class="table-tr">-->
<!--                                    <th class="table-th">{{lang("Domain")}}</th>-->
<!--                                    <th class="table-th">{{lang("Goals")}}</th>-->
<!--                                    <th class="table-th">{{lang("Indicator")}}</th>-->
<!--                                    <th class="table-th">{{lang("Action")}}</th>-->
<!--                                </tr>-->
<!--                                </thead>-->

<!--                                <tr v-for="(porDevelopmentObjectValueInfo, index) in porDevelopmentObject">-->
<!--                                    <td class="table-td">{{porDevelopmentObjectValueInfo.Domain}}</td>-->
<!--                                    <td class="table-td">{{porDevelopmentObjectValueInfo.Goals}}</td>-->
<!--                                    <td class="table-td"><input type="text" class="form-control"-->
<!--                                                                :value="porDevelopmentObjectValueInfo.Indicator"-->
<!--                                                                style="margin: 0px;" /></td>-->
<!--                                    <td class="table-td"><el-button @click="removeSelectedGoals(porDevelopmentObjectValueInfo, index)">{{lang("Delete")}}</el-button></td>-->
<!--                                </tr>-->
<!--                            </table>-->

                                <data-tables :data="porDevelopmentObject">
                                    <el-table-column v-for="porDevelopmentObjectValueInfo in porDevelopmentObjectValue" :prop="porDevelopmentObjectValueInfo.prop"
                                                     :label="porDevelopmentObjectValueInfo.label" :key="porDevelopmentObjectValueInfo.prop"
                                                     sortable="custom">
                                    </el-table-column>
                                </data-tables>
                        </div>
                        <div class="col-md-6 formDiv"
                             :class="{ 'form-group--error': $v.obj_Post.PostPorDtlAnalysisReflection.$error }">
                            <label>{{lang("Analysis")}}</label>
                            <!--<select v-model="obj_Post.PostPorDtlAnalysisReflection" type="text" class="form-control"-->
                            <!--id="tb_AnalysisReflection">-->
                            <!--<option disabled value="">Please select one</option>-->
                            <!--<option value="Option 1">Option 1</option>-->
                            <!--</select>-->
                            <!--                            <input v-model="obj_Post.PostPorDtlAnalysisReflection" type="textarea" class="form-control"-->
                            <!--                                   :placeholder="lang('Analysis')" readonly="readonly"-->
                            <!--                                   v-model.trim="$v.obj_Post.PostPorDtlAnalysisReflection.$model"/>-->
                            <textarea rows="2" v-model="obj_Post.PostPorDtlAnalysisReflection" type="textarea" class="form-control"
                                      :placeholder="lang('Analysis')" readonly="readonly"
                                      v-model.trim="$v.obj_Post.PostPorDtlAnalysisReflection.$model"></textarea>
                            <div class="error requiredFieldsMsg"
                                 v-if="!$v.obj_Post.PostPorDtlAnalysisReflection.required">
                                <el-alert
                                        :title="lang('Analysis is required')"
                                        type="error">
                                </el-alert>
                            </div>
                        </div>

                        <div class="col-md-6 formDiv"
                             :class="{ 'form-group--error': $v.arrEnduringThemesSelection.$error }">
                            <label>{{lang("Enduring Themes")}}</label>
                            <el-select v-model="arrEnduringThemesSelection" :placeholder="lang('Enduring Themes')" multiple
                                       class="pro-edt-select fullWidth mb-3 postPortfolioComponentPage"
                                       v-model.trim="$v.arrEnduringThemesSelection.$model" @change="setPortfolioDropdown()">
                                <el-option v-for="item in ddlEnduringThemesList"
                                           class="ddlEnduringThemesOption"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>

                            <div class="error requiredFieldsMsg"
                                 v-if="!$v.arrEnduringThemesSelection.required">
                                <el-alert
                                        :title="lang('Enduring Themes is required')"
                                        type="error">
                                </el-alert>
                            </div>
                        </div>

                        <div class="col-md-6 formDiv"
                             :class="{ 'form-group--error': $v.arrBigIdeasSelection.$error }">
                            <label>{{lang("Big Ideas")}}</label>
                            <!--                            <el-select v-model="arrBigIdeasSelection" :placeholder="lang('Big Ideas')" multiple-->
                            <!--                                       class="pro-edt-select fullWidth mb-3 postPortfolioComponentPage"-->
                            <!--                                       v-model.trim="$v.arrBigIdeasSelection.$model" @change="setPortfolioDropdown()">-->
                            <!--                                <el-option v-for="item in ddlBigIdeasList"-->
                            <!--                                           class="ddlBigIdeasOption"-->
                            <!--                                           :key="item.value"-->
                            <!--                                           :label="item.label"-->
                            <!--                                           :value="item.value">-->
                            <!--                                </el-option>-->
                            <!--                            </el-select>-->
                            <el-select v-model="arrBigIdeasSelection" :placeholder="lang('Big Ideas')" multiple
                                       class="pro-edt-select fullWidth mb-3 postPortfolioComponentPage"
                                       v-model.trim="$v.arrBigIdeasSelection.$model" >
                                <el-option v-for="item in ddlBigIdeasList"
                                           class="ddlBigIdeasOption"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>

                            <div class="others-types-container" v-if="isOthers">
                                <input v-model="inputOthersBigIdeas" type="text" class="form-control"/>
                                <el-button @click="setPortfolioDropdown()">{{lang("Add")}}</el-button>
                            </div>

                            <div class="selected-big-ideas-list-container">
                                <label>{{tagsInputBigIdeas}}</label>
                            </div>

                            <!--                            <el-dropdown class="w-100" split-button type="default" v-model="arrBigIdeasSelection"-->
                            <!--                                         v-model.trim="$v.arrBigIdeasSelection.$model" @change="selectBigIdeasDropdown">-->
                            <!--                                <el-input-->
                            <!--                                        class="input-new-tag"-->
                            <!--                                        v-model="tagsInputBigIdeas"-->
                            <!--                                        ref="saveTagInput"-->
                            <!--                                        size="mini"-->
                            <!--                                        @blur="handleInputConfirm"-->
                            <!--                                >-->
                            <!--                                </el-input>-->
                            <!--                                <el-dropdown-menu slot="dropdown">-->
                            <!--                                    <el-dropdown-item v-for="item in ddlBigIdeasList"-->
                            <!--                                          class="ddlBigIdeasOption"-->
                            <!--                                          :key="item.value"-->
                            <!--                                          :label="item.label"-->
                            <!--                                          :value="item.value"-->
                            <!--                                          :command="item.value">{{item.value}}-->
                            <!--                                    </el-dropdown-item>-->
                            <!--                                </el-dropdown-menu>-->
                            <!--                            </el-dropdown>-->

                            <!--                            <div class="selected-big-ideas-list-container">-->
                            <!--                                <el-tag-->
                            <!--                                        :key="tag"-->
                            <!--                                        v-for="tag in dynamicTagsBigIdeas"-->
                            <!--                                        closable-->
                            <!--                                        :disable-transitions="false"-->
                            <!--                                        @close="handleClose(tag)">-->
                            <!--                                    {{tag}}-->
                            <!--                                </el-tag>-->
                            <!--                            </div>-->

                            <div class="error requiredFieldsMsg"
                                 v-if="!$v.arrBigIdeasSelection.required">
                                <el-alert
                                        :title="lang('Big Ideas is required')"
                                        type="error">
                                </el-alert>
                            </div>
                        </div>

                        <div class="col-md-6 formDiv"
                             :class="{ 'form-group--error': $v.arrKeyConceptsSelection.$error }">
                            <label>{{lang("Key Concepts")}}</label>
                            <el-select v-model="arrKeyConceptsSelection" :placeholder="lang('Key Concepts')" multiple
                                       class="pro-edt-select fullWidth mb-3 postPortfolioComponentPage"
                                       v-model.trim="$v.arrKeyConceptsSelection.$model" @change="setPortfolioDropdown()">
                                <el-option v-for="item in ddlKeyConceptsList"
                                           class="ddlKeyConceptsOption"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>

                            <div class="error requiredFieldsMsg"
                                 v-if="!$v.arrKeyConceptsSelection.required">
                                <el-alert
                                        :title="lang('Big Ideas is required')"
                                        type="error">
                                </el-alert>
                            </div>
                        </div>

                        <div class="col-md-12 formDiv">
                            <tags-component :parent_Post="post" @tags="setPortfolioTags" :portfolio_Type="portfolio_Type"
                                            ref="studentListComponent"></tags-component>
                        </div>
                    </div>
                    <div class="row justify-content-center form-footer">
                        <div class="col-6">
                            <input type="reset" @click="resetAll" class="btn btn-secondary float-left" :value="lang('Cancel')"/>
                        </div>
                        <div class="col-6">
                            <input type="submit" class="btn btn-primary " :value="lang('Submit')" @click="Validation"/>
                        </div>
                    </div>
                </form>
                <!-- END Others content for "Portfolio" -->

            </div>

            <!--            Gallery List Modal-->
            <b-modal id="modal_GalleryListModal" hide-footer size="lg" title="New Post"
                     ref="ref_modal_GalleryListModal" centered v-model="isModalOpen">
                <component :is="obj_SelectedComponent"
                           :arrobjFolderPath="arrobj_FolderPath"
                           v-on:childToParent="getChildtoParent"
                           :displayListMode="displayListMode"
                           @hidden="hideComponentModal">
    <!--                    v-on:childToParent="getChildtoParent"
                            :arrobjFolderPath="arrobj_FolderPath"
                            :displayListMode="displayListMode"
                            :arrobjFolders="arrobj_Folders"
                            :arrobjFiles="arrobj_Files"
                            :intStartRowNo="int_StartRowNo"
                            :intEndRowNo="int_EndRowNo"-->
                </component>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import DataSource from "../data/datasource";
    import tagsComponent from "./Post_Tags_Component";
    import galleryListComponent from "../components/galleryListComponent";
    import $j from "jquery";
    import {required, requiredIf, requiredUnless, email} from "vuelidate/lib/validators";
    import {lang} from '../locale/index';
    import pdf from 'vue-pdf';

    export default {
        name: "newPostComponent",
        data() {
            return {
                /* FEED variable */
                PostID: "",
                addPostContent: "",
                tagClassID: "",
                tagLevelID: "",
                classesTable: [],
                levelsTable: [],
                tag: '',
                tags: [],
                selectedFile: [],
                systemmsgError: false,
                error: "",
                results: "",
                academicYearTable: [],
                studentTable: [],
                loading: false,
                uploadedFiles: [],
                clickCount: 0,
                /* FEED variable */

                /* PORTFOLIO variable */
                // CLS_CLassName, Profile_Img, Student_ID, Student_Name
                arrobj_Levels: [],
                arrobj_SelectedStudents: [],
                slide: 0,
                sliding: null,
                arrobj_SelectedFiles: [],
                obj_Post: {
                    PostID: "",
                    PostPorDtlTitle: "",
                    PostPorDtlObservation: "",
                    PostPorDtlAnalysisReflection: "",
                    PostPorDtlDevelopmentGoals: []
                },

                portfolio_Type: 'Yes',
                ddlClassList: [],
                ddlClass: '',
                ddlGoalsList: [],
                porDevelopmentObject: [],
                porDevelopmentObjectValue: [{
                    prop: "Domain",
                    label: lang("Domain")
                }, {
                    prop: "Goals",
                    label: lang("Goals")
                }, {
                    prop: "Indicator",
                    label: lang("Indicator")
                }],

                sortedGoalList: [],
                arrEnduringThemesSelection: [],
                ddlEnduringThemesList:[
                    {
                        value: 'Term 1',
                        label: 'Term 1'
                    },
                    {
                        value: 'Term 4',
                        label: 'Term 4'
                    },
                ],
                arrBigIdeasSelection: [],
                ddlBigIdeasList:[
                    {
                        value: 'Term 2',
                        label: 'Term 2'
                    },
                    {
                        value: 'Term 3',
                        label: 'Term 3'
                    },
                    {
                        value: 'Others',
                        label: 'Others'
                    },
                ],
                arrKeyConceptsSelection: [],
                ddlKeyConceptsList: [
                    {
                        value: 'Term 1',
                        label: 'Term 1'
                    }, {
                        value: 'Term 2',
                        label: 'Term 2'
                    }, {
                        value: 'Term 3',
                        label: 'Term 3'
                    }, {
                        value: 'Term 4',
                        label: 'Term 4'
                    },
                ],

                arrobj_selectedMultiplePortfolio: [],
                tagsInputBigIdeas: '',
                dynamicTagsBigIdeas: [],
                isOthers: false,
                inputOthersBigIdeas: '',
                /* PORTFOLIO variable */

                /* Gallery List variable */
                obj_SelectedComponent: false,
                isModalOpen: false,
                arrobj_FolderPath: [{GalFolder: lang("Gallery"), GalID: "PRIMARY", GalType: "Folder"}],
                /* Gallery List variable */
            };
        },
        validations: {
            /* for FEED */
            addPostContent: {
                requiredIf: requiredIf('feedValidationType')
            },
            /* for FEED */

            /* for PORTFOLIO */
            obj_Post: {
                PostPorDtlTitle: {
                    requiredIf: requiredIf('portfolioValidationType')
                },
                PostPorDtlObservation: {
                    requiredIf: requiredIf('portfolioValidationType')
                },
                PostPorDtlDevelopmentGoals: {
                    requiredIf: requiredIf('portfolioValidationType')
                },
                PostPorDtlAnalysisReflection: {
                    requiredIf: requiredIf('portfolioValidationType')
                }
            },
            ddlClass: {
                requiredIf: requiredIf('portfolioValidationType')
            },
            arrEnduringThemesSelection: {
                requiredIf: requiredIf('portfolioValidationType')
            },
            arrBigIdeasSelection: {
                requiredIf: requiredIf('portfolioValidationType')
            },
            arrKeyConceptsSelection: {
                requiredIf: requiredIf('portfolioValidationType')
            },
            /* for PORTFOLIO */
        },
        methods: {
            lang,
            sleep(milliseconds) {
                return new Promise(resolve => setTimeout(resolve, milliseconds));
            },
            init() {
                if (this.displayListMode === 'Feed') {
                    DataSource.shared.getPostDropdown().then((tagResponse) => {
                        if (tagResponse.AcademicYearTable && tagResponse.AcademicYearTable.Table) {
                            let uniqueYears = [];
                            tagResponse.AcademicYearTable.Table.forEach(object => {
                                const isExist = uniqueYears.find(year => year.SMT_Code === object.SMT_Code);
                                if (!isExist) {
                                    uniqueYears.push(object);
                                }
                            });
                            this.academicYearTable = uniqueYears;
                        }
                        if (tagResponse.ClassesTable && tagResponse.ClassesTable.Table) {
                            let uniqueClass = [];
                            tagResponse.ClassesTable.Table.forEach(object => {
                                const isExist = uniqueClass.find(year => year.PK_Class_ID === object.PK_Class_ID);
                                if (!isExist) {
                                    uniqueClass.push(object);
                                }
                            });
                            this.classesTable = uniqueClass;
                        }
                        if (tagResponse.LevelsTable && tagResponse.LevelsTable.Table) {

                            let uniqueLevel = [];
                            tagResponse.LevelsTable.Table.forEach(object => {
                                const isExist = uniqueLevel.find(level => level.SC_FK_CourseID === object.SC_FK_CourseID);
                                if (!isExist) {
                                    uniqueLevel.push(object);
                                }
                            });

                            this.levelsTable = uniqueLevel;
                        }
                        if (tagResponse.StudentTable && tagResponse.StudentTable.Table) {
                            let uniqueStudent = [];
                            tagResponse.StudentTable.Table.forEach(object => {
                                const isExist = uniqueStudent.find(student => student.Student_ID === object.Student_ID);
                                if (!isExist) {
                                    const selectedValue = {
                                        Student_ID: object.Student_ID,
                                        text: object.Full_Name,
                                        Sex: object.Sex,
                                        // email: object.email,
                                        Status: object.Status
                                    };
                                    uniqueStudent.push(selectedValue);
                                }
                            });
                            // this.studentTable = tagResponse.StudentTable.Table;
                            this.studentTable = uniqueStudent;
                        }
                    });
                }

                if (this.displayListMode === 'Portfolio') {
                    this.getStudents().then((result) => {
                        let sortedList = this.groupBy(result, "SMT_Code");

                        for (let i = 0; i < sortedList.length; i++) {
                            let temp = this.groupBy(sortedList[i].ArrObj_Items, "CRS_Course_Name");
                            sortedList[i].ArrObj_Items = temp;
                        }

                        this.arrobj_Levels = sortedList;
                    });

                    this.bindClasses();
                }
            },

            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined");
            },
            isImageByExt(obj_File) {
                let ext = String(obj_File.PostItemFileExt).toUpperCase();
                let isImage = false;

                switch (ext) {
                    case ".PNG":
                    case ".JPG":
                    case ".BMP":
                    case ".GIF":
                    case ".JPEG":
                        isImage = true;
                        break;
                    default:
                        isImage = false;
                        break;
                }

                return isImage;
            },
            isMedia(ext) {
                ext = String(ext).toUpperCase();
                let isMedia = false;

                switch (ext) {
                    case ".PDF":
                    case ".MP4":
                    case ".MP3":
                    case ".AAC":
                    case ".WAV":
                    case ".M4A":
                        isMedia = true;
                        break;
                    default:
                        isMedia = false;
                        break;
                }

                return isMedia;
            },
            checkIfImage(file) {
                const fileType = file.type.toLowerCase();
                switch (fileType) {
                    case "image/jpeg":
                    case "image/png":
                    case "image/jpg":
                    case "image/gif":
                        return true;
                    // case "video/mp4":
                    //     return "video/mp4";
                    default:
                        return false;
                }
            },


            //return a promise that resolves with a File instance
            urltoFile(url, filename, mimeType) {
                return (fetch(url)
                        .then(function (res) {
                            return res.arrayBuffer();
                        })
                        .then(function (buf) {
                            // console.log(buf, "buf");
                            return new File([buf], filename, {type: (mimeType === "audio/vnd.dlna.adts" ? "audio/aac" : mimeType)});
                        })
                );
            },
            setTags(value) {
                this.tags = value;
            },


            onFileChanged(event) {
                // this.selectedFile = event.target.files;
                for (let file of event.target.files) {
                    if (file.size > 10048576) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'File limit exceeded 10MB!'
                        });
                    } else {
                        this.selectedFile.push(file);
                    }
                }
                // if (this.selectedFile.size > 5048576) {
                //     alert("File is too big!");
                //     this.selectedFile = "";
                // }
                this.getImagePreviews();
            },
            inputChange(input) {
                this.postContent = input;
            },

            getImagePreviews() {
                /*
                  Iterate over all of the files and generate an image preview for each one.
                */
                for (let i = 0; i < this.selectedFile.length; i++) {
                    /*
                      Ensure the file is an image file
                    */
                    if (/\.(jpe?g|png|gif)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */

                        reader.addEventListener("load", function () {
                            this.$refs['image' + parseInt(i)][0].src = reader.result;
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }

                    if (/\.(mp4|mp3|aac|wav|m4a)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();
                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            this.$refs['video' + parseInt(i)][0].src = reader.result;
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }

                    if (/\.(doc?x)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            this.$refs['image' + parseInt(i)][0].src = "../assets/docx-icon.png";
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }

                    if (/\.(xls?x)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            this.$refs['image' + parseInt(i)][0].src = "../assets/excel-icon.png";
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }

                    if (/\.(pdf)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            this.$refs['pdf' + parseInt(i)][0].src = reader.result;
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }
                }
            },
            removePreviewImg(fileName) {

                this.selectedFile = this.selectedFile.filter(d => {
                    return d.name !== fileName;
                });

                this.getImagePreviews()
            },
            clearPreview() {
                $j("#inputfile").val("");
                this.selectedFile = [];
            },
            resetAll() {
                this.clearPreview();
                this.$emit("result", "CANCEL");
            },

            successMsg() {

            },
            errorMsg() {

            },
            Validation(){
                this.$v.$touch();
            },
            async onSubmit() {

                if (!this.$v.$error) {

                    if (this.selectedFile.length <= 0) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please Upload Files!'),
                        });
                        return;
                    }

                    if (this.tags.length <= 0) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please Select Tags'),
                        });
                        return;
                    } else {
                        this.error = "";
                        this.$vs.loading();
                        await this.sleep(500);

                        try {
                            const saveResponse = await DataSource.shared.savePostUpdate(this.selectedFile, this.addPostContent, this.tags, this.tagClassID, this.tagLevelID, this.PostID);
                            if (saveResponse) {

                                if (saveResponse.code == "1")
                                    this.$emit("result", "TRUE");
                                else
                                    this.$emit("result", "FALSE");
                                switch (saveResponse.code) {
                                    case "1":
                                        this.$emit("notifChange");
                                        this.$emit("loadPosts");
                                        this.isModalOpen = false;
                                        // reset all input filed to blank
                                        this.selectedFile = [];
                                        this.$refs.fileupload.value = "";
                                        this.addPostContent = "";
                                        this.tagAcademicYearID = null;

                                        this.tagLevelID = null;
                                        this.tagClassID = null;
                                        this.results = `Post Submitted`;
                                        // this.success = '';
                                        this.$notify({
                                            title: lang('Success'),
                                            message: lang('Post Submitted, activity will be active in a while'),
                                            type: 'success'
                                        });
                                        await DataSource.shared.softDeletePost(this.PostID);

                                        this.$vs.loading.close();
                                        break;
                                    case "88":
                                        this.$vs.loading.close();
                                        this.$notify.error({
                                            title: lang('Error'),
                                            message: lang('Please Login to submit post')
                                        });
                                        this.systemmsgError = true;
                                        break;
                                    case "99":
                                        this.$vs.loading.close();
                                        this.$notify.error({
                                            title: lang('Error'),
                                            message: lang('Please fill in content')
                                        });
                                        this.systemmsgError = true;
                                        break;
                                    // default:
                                    //     alert("Please try again later");
                                    //     this.results = JSON.stringify(response);
                                }

                                // this.$emit("hidden");
                            }
                        } catch (e) {
                            console.log(e);
                            this.error = e;
                        }
                    }
                }
            },

            getStudents() {
                return new Promise((resolve, reject) => {
                    DataSource.shared.getAllActiveStudentsBySchool().then((result) => {
                        resolve(result.Table);
                    });
                });
            },
            async bindClasses() {
                try {
                    const response = await DataSource.shared.getAttendanceClass();
                    if (response) {
                        this.class = response.Table;
                        this.class.forEach(m => {
                            this.ddlClassList.push(m);
                        });
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            changeClass() {
                this.$refs.studentListComponent.filterByClassIDChange(this.ddlClass);
                this.getPlannerAssignedStudentsGroupByClassID('');
            },
            async getPlannerAssignedStudentsGroupByClassID(studentID) {
                try {
                    if (studentID === '') {
                        const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassID(this.ddlClass, '');

                        if (response) {
                            if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                console.log('getPlannerAssignedStudentsGroupByClassID Error');
                            } else if (response.code === '2') {
                                this.obj_Post.PostPorDtlDevelopmentGoals = [];
                                this.ddlGoalsList = [];
                            } else {
                                this.obj_Post.PostPorDtlDevelopmentGoals = [];
                                this.ddlGoalsList = response.Table;
                            }
                        }
                    } else {
                        //reset all to No
                        this.ddlGoalsList = this.ddlGoalsList.map(m=> {
                            m.Included = 'No';
                            console.log('1');
                            return m;
                        });
                        //reset all to No

                        let StudentIDList = [];

                        studentID.forEach(item => {
                            let tempStudentIDList = {
                                StudentID: item,
                            };

                            StudentIDList.push(tempStudentIDList);
                        });

                        if (StudentIDList.length > 0){
                            const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassID(this.ddlClass, JSON.stringify(StudentIDList));

                            if (response) {
                                if (response.code === '88') {
                                    window.location.replace('/');
                                } else if (response.code === '99') {
                                    console.log('getPlannerAssignedStudentsGroupByClassID Error');
                                } else if (response.code === '2') {
                                    console.log('getPlannerAssignedStudentsGroupByClassID no record');
                                } else {
                                    //set those available to Yes
                                    response.Table.forEach(item => {
                                        this.ddlGoalsList = this.ddlGoalsList.map(m=> {
                                            if (m.PlnStaIndicator === item.PlnStaIndicator) {
                                                m.Included = 'Yes';
                                            }
                                            console.log('2');
                                            return m;
                                        });
                                    });
                                    //set those available to Yes
                                }
                            }
                        }
                    }

                    let sortedList = this.groupBy(this.ddlGoalsList, "PlnStaDomain");

                    this.sortedGoalList = sortedList;
                } catch (e) {
                    this.results = e;
                }
            },
            setValidateDropdown(value) {
                this.$v.obj_Post.PostPorDtlDevelopmentGoals.$touch();

                this.porDevelopmentObject = [];
                this.obj_Post.PostPorDtlAnalysisReflection = "";

                this.obj_Post.PostPorDtlDevelopmentGoals.forEach(item => {
                    this.ddlGoalsList.forEach(m => {
                        if (item === m.PlnStaIndicator) {
                            let porDevelopmentObjectTemp = {
                                Domain: m.PlnStaDomain,
                                Goals: m.PlnStaGoals,
                                Indicator: m.PlnStaIndicator,
                            };

                            this.porDevelopmentObject.push(porDevelopmentObjectTemp);
                            this.obj_Post.PostPorDtlAnalysisReflection += m.PlnStaIndicator + '\n';
                        }
                    });
                });
            },

            async verifyPost() {
                try {

                    if (this.selectedFile.length <= 0) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please Upload Files!'),
                        });
                        return;
                    }

                    if (!this.$v.$error) {
                        this.$vs.loading();
                        if (this.isNull(this.obj_Post.PostPorDtlTitle) ||
                            this.isNull(this.obj_Post.PostPorDtlObservation) ||
                            this.isNull(this.obj_Post.PostPorDtlAnalysisReflection) ||
                            this.isNull(this.obj_Post.PostPorDtlDevelopmentGoals) ||
                            this.isNull(this.arrobj_SelectedStudents) ||
                            this.isNull(this.arrEnduringThemesSelection) ||
                            this.isNull(this.arrBigIdeasSelection) ||
                            this.isNull(this.arrKeyConceptsSelection)) {

                            setTimeout(() => {
                                this.$vs.loading.close();
                            }, 500);

                            // this.$emit("result", "FALSE");
                            this.$notify.error({
                                title: lang('Error'),
                                message: lang('Please fill in content')
                            });
                            return;
                        }

                        // console.log('2');
                        await this.sleep(1000);

                        /*let studentsIds = this.arrobj_SelectedStudents.map(x => x.Student_ID);*/
                        const response = await DataSource.shared.savePortfolioPost(this.selectedFile,
                            this.obj_Post.PostPorDtlTitle,
                            this.obj_Post.PostPorDtlObservation,
                            this.obj_Post.PostPorDtlAnalysisReflection,
                            JSON.stringify(this.porDevelopmentObject),
                            this.arrobj_SelectedStudents, "", "",
                            this.obj_Post.PostID,
                            JSON.stringify(this.arrobj_selectedMultiplePortfolio));

                        if (response) {
                            if (!this.isNull(response) && response.code === "1") {
                                this.$notify({
                                    title: lang('Success'),
                                    message: lang('Portfolio added'),
                                    type: 'success'
                                });
                                this.$emit("result", "TRUE");
                                await DataSource.shared.softDeletePost(this.obj_Post.PostID);
                            } else
                                this.$emit("result", "FALSE");
                        }

                        // this.$notify({
                        //     title: lang('Success'),
                        //     message: lang('Portfolio added'),
                        //     type: 'success'
                        // });
                        this.$vs.loading.close();
                        // DataSource.shared.savePortfolioPost(this.arrobj_SelectedFiles,
                        //     this.obj_Post.PostPorDtlTitle,
                        //     this.obj_Post.PostPorDtlObservation,
                        //     this.obj_Post.PostPorDtlAnalysisReflection,
                        //     this.obj_Post.PostPorDtlDevelopmentGoals,
                        //     this.arrobj_SelectedStudents, "", "",
                        //     this.obj_Post.PostID)
                        //     .then((result) => {
                        //
                        //         console.log("333")
                        //
                        //         if (!this.isNull(result) && result.code == "1") {
                        //             this.$emit("result", "TRUE");
                        //
                        //             DataSource.shared.softDeletePost(this.obj_Post.PostID);
                        //         }
                        //         else
                        //             this.$emit("result", "FALSE");
                        //     });
                    }

                } catch (e) {
                    this.results = e;
                }

            },
            removeSelectedGoals(gItem, gIndex) {
                this.ddlGoalsList = this.ddlGoalsList.filter((d, dIndex) => {
                    return dIndex !== gIndex;
                });
                //
                // this.ddlGoalsList.splice(this.ddlGoalsList.indexOf(itemIndex), 1);
                //
                // this.setValidateDropdown(this.ddlGoalsList);
            },
            setPortfolioDropdown() {
                this.$v.arrEnduringThemesSelection.$touch();
                this.$v.arrBigIdeasSelection.$touch();
                this.$v.arrKeyConceptsSelection.$touch();

                this.arrobj_selectedMultiplePortfolio = [];

                if (!this.isNull(this.arrEnduringThemesSelection)) {
                    this.arrEnduringThemesSelection.forEach(item => {
                        let objItem = {};
                        objItem.Type = "EnduringThemes";
                        objItem.Value = item;

                        this.arrobj_selectedMultiplePortfolio.push(objItem);
                    });
                }

                if (!this.isNull(this.arrBigIdeasSelection)) {

                    this.arrBigIdeasSelection.forEach(item => {
                        let objItem = {};
                        objItem.Type = "BigIdeas";
                        objItem.Valus = item;

                        this.arrobj_selectedMultiplePortfolio.push(objItem);
                    });
                }

                if (!this.isNull(this.arrKeyConceptsSelection)) {
                    this.arrKeyConceptsSelection.forEach(item => {
                        let objItem = {};
                        objItem.Type = "Concepts";
                        objItem.Value = item;

                        this.arrobj_selectedMultiplePortfolio.push(objItem);
                    });
                }
            },
            setPortfolioTags(value) {
                this.arrobj_SelectedStudents = value;
                this.getPlannerAssignedStudentsGroupByClassID(this.arrobj_SelectedStudents);
            },

            groupBy(data, key) {
                let ArrObj_Sorted = [];

                for (let item of data) {
                    let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key]);

                    if (index === -1) {
                        ArrObj_Sorted.push({Str_SortBy: item[key], ArrObj_Items: [item]});
                    } else
                        ArrObj_Sorted[index].ArrObj_Items.push(item);
                }

                return ArrObj_Sorted;
            },

            getChildtoParent(arrobjSelectedFile) {
                this.selectedFile = [];

                if (!this.isNull(arrobjSelectedFile)) {
                    for (let image of arrobjSelectedFile) {
                        // let url = "data:" + image.GalFileType + ";base64," + (!this.isMedia(image.GalFileExt) ? image.GalFileLow : image.GalFile);
                        // let url = "data:" + image.GalFileType + ";base64," + image.GalFile;
                        let url = image.FilePath;
                        let fileName = image.GalFileName + image.GalFileExt;
                        let mimeType = image.GalFileType;

                        this.urltoFile(url, fileName, mimeType).then((file) => {
                            this.selectedFile.push(file);
                        }).finally(() => {
                            this.getImagePreviews();
                        });
                    }
                }

                this.hideComponentModal();
            },

            showGalleryList() {
                this.obj_SelectedComponent = galleryListComponent;
                this.isModalOpen = true;
            },
            hideComponentModal() {
                this.obj_SelectedComponent = false;
                this.isModalOpen = false;
                this.modalTitle = null;
            },
        },
        mounted() { // still need to addon (audio & video)
            this.init();

            // if (!this.isNull(this.images)) {
            //
            //     this.selectedFile = [];
            //     for (let image of this.images) {
            //         // let url = "data:" + image.GalFileType + ";base64," + (!this.isMedia(image.GalFileExt) ? image.GalFileLow : image.GalFile);
            //         let url = "data:" + image.GalFileType + ";base64," + image.GalFile;
            //         let fileName = image.GalFileName + image.GalFileExt;
            //         let mimeType = image.GalFileType;
            //
            //         this.urltoFile(url, fileName, mimeType).then((file) => {
            //             this.selectedFile.push(file);
            //         }).finally(() => {
            //             this.getImagePreviews();
            //         });
            //     }
            // }

            // const self = this;
            // $j("#upload-file-box").off("click").on("click", function (e) {
            //     // self.onFileChanged(e);
            //     $j("#inputfile").click();
            // });
        },
        computed: {
            items() {
                return this.studentTable.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                });
            },

            feedValidationType() {
                if (this.displayListMode === 'Feed') {
                    return true;
                } else {
                    return false;
                }
            },

            portfolioValidationType() {
                if (this.displayListMode === 'Portfolio') {
                    return true;
                } else {
                    return false;
                }
            },
        },
        components: {
            tagsComponent,
            pdf,
            galleryListComponent,
        },
        props: ["displayListMode", "post"],
    }
</script>

<style scoped>
    .upload-file-list-container {
        display: inline-block;
        margin-bottom: 20px;
    }

    .each-file-container {
        display: inline-block;
        height: 200px;
        width: 200px;
        vertical-align: top;
        margin: 0 20px 20px 0;
        border: 1px solid #ccc;
        border-radius: 8px;
        position: relative;
    }

    .each-file-container .each-file {
        display: block;
        height: 100%;
        width: 100%;
    }

    .each-file-container span img {
        /*object-fit: cover;*/
        width: 100%;
        height: 100%;
        border-radius: 6px;

        padding: 10px;
        object-fit: contain;
        /*background: #ccc;*/
    }

    .upload-file-box {
        width: 200px;
        height: 200px;
        border: 1px solid #ccc;
        border-radius: 8px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
        padding: 80px 0;
    }

    .each-file-close {
        position: absolute;
        top: -15px;
        right: -5px;
        background: white;
        width: 30px;
        height: 30px;
        padding: 0 10px;
        border-radius: 50%;
        border: 1px solid #ccc;
        display: block;
        cursor: pointer;
    }

    .media-file-video {
        max-width: 100%;
        height: 100%;
        padding: 10px;
        border-radius: 6px;
        object-fit: contain;
    }

    #carousel1 img {
        height: 250px;
    }

    .fullWidth {
        width: 100%;
    }

    .formDiv {
        margin-top: 20px;
    }

    .ddlDevelopmentGoalsOption {
        max-width: 450px;
    }

    .ddlDevelopmentGoalsOptionBGColor {
        background-color: #F0E68C !important;
    }

    .upload-file-list-container {
        display: inline-block;
        margin-bottom: 20px;
    }

    .each-file-container {
        display: inline-block;
        height: 200px;
        width: 200px;
        vertical-align: top;
        margin: 0 20px 20px 0;
        border: 1px solid #ccc;
        border-radius: 8px;
        position: relative;
    }

    .each-file-container .each-file {
        display: block;
        height: 100%;
        width: 100%;
    }

    .each-file-container span img {
        object-fit: contain;
        width: 100%;
        height: 100%;
        border-radius: 6px;
        padding: 10px;
    }

    .upload-file-box {
        width: 200px;
        height: 200px;
        border: 1px solid #ccc;
        border-radius: 8px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
        padding: 80px 0;
    }

    .each-file-close {
        position: absolute;
        top: -15px;
        right: -5px;
        background: white;
        width: 30px;
        height: 30px;
        padding: 0 10px;
        border-radius: 50%;
        border: 1px solid #ccc;
        display: block;
        cursor: pointer;
    }

    .media-file-video {
        max-width: 100%;
        height: 100%;
        padding: 10px;
        border-radius: 6px;
        object-fit: contain;
    }
</style>

<style>
    .postPortfolioComponentPage .el-tag {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>